jQuery(function ($) {
  // Detect if there is a product list
  let productList = document.querySelector("#js-product-list");

  // Get all attribues names from the id of the DOM elements
  const getAttributes = function () {
    let attributes = [];
    $(".filter__content--attributes").each(function (index) {
      attributes.push($(this).attr("id"));
    });

    return attributes;
  };

  /**
   * Get a search filter value by its name
   */
  const getFilterValue = function (filterName) {
    let values = [];
    $("input." + filterName + "-checked").each(function (index, checkbox) {
      if ($(checkbox).is(":checked")) {
        values.push($(this).val());
      }
    });
    return values;
  };

  // Create an array of all the attributes
  let attributes = [];
  attributes = getAttributes();

  if (productList) {
    // Search initialization
    let page = 0;
    let busy = false;
    let cat = {
      category: [],
    };

    // Create an object filter with the attributes we got from the function getAttributes
    let filter = attributes.reduce((op, inp, i) => {
      op[inp] = op[inp] || [];
      op[inp].push(i);
      return op;
    }, {});

    const $loading = $("#loading");

    // Function called when a search is triggered by the user
    const triggerProductsSearch = (pageIndex = 1) => {
      // Bail early if a search is already happening
      if (busy) return;

      busy = true;

      // Empty products list before search
      productList.innerHTML = "";

      page = pageIndex;

      // Assign the values from the search bar and assign them to the filter object
      attributes.forEach((attr) => (filter[attr] = getFilterValue(attr)));

      // Attribute the value of the category value to the cat ajax filter
      cat.category = getFilterValue("category");

      // Trigger AJAX products search request
      const request = $.ajax({
        url: ajaxurl.ajaxurl,
        method: "POST",
        data: {
          action: "get_product",
          params: {
            page,
            filter,
            cat,
          },
        },
        beforeSend: showLoadingIndicator,
      });

      request.done(onProductsSearchDone);
      request.always(hideLoadingIndicator);
    };

    // Function called when the search ajax request is done
    const onProductsSearchDone = (data) => {
      if (data.success) {
        // If length is different than 10 (10 equals to no products found) show the product list or display a message
        if (data.data.html.length !== 10) {
          productList.innerHTML = data.data.html;
        } else {
          productList.innerHTML =
            "Pas de correspondance, veuillez modifier votre recherche";
        }

        // Pagination click => lance une recherche (on garde)
        $(".pagination-item > a")
          .off("click")
          .on("click", function (e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });

            triggerProductsSearch(e.target.getAttribute("data-page"));
          });

        // ❌ IMPORTANT : on ne déclenche PLUS la recherche au changement des checkbox
        // $('.page-products__filters').on('change', 'input:checkbox', function() {
        //   triggerProductsSearch();
        // });

        busy = false;
      } else {
        productList.innerHTML = "Pas de correspondance..";
        busy = false;
      }
    };

    // Function called before search
    const showLoadingIndicator = () => {
      $(".page-products__filters input:checkbox").attr("disabled", true);
      $(".page-products__filters").addClass("busy");
      $loading.show();
    };

    // Function called after search
    const hideLoadingIndicator = () => {
      $(".page-products__filters input:checkbox").removeAttr("disabled");
      $(".page-products__filters").removeClass("busy");
      $loading.hide();
    };

    // Reset the AJAX search
    const resetSearch = function () {
      $(".filters-list__item-checkbox").prop("checked", false);
    };

    // Trigger products search on DOM ready
    $(document).ready(function () {
      // ✅ Garde le chargement initial de la liste (si tu ne le veux pas, commente la ligne suivante)
      triggerProductsSearch();

      // ✅ La recherche ne se fait QUE si on clique sur le bouton
      // (si ton bouton doit aussi reset les filtres, dé-commente resetSearch())
      $(".filter__button--delete")
        .off("click")
        .on("click", function (e) {
          e.preventDefault();

          // Si tu veux que ce bouton "supprime la recherche" (reset), dé-commente :
          // resetSearch()

          // Lance la recherche uniquement au clic
          triggerProductsSearch();
        });
    });
  }
});
